import React from "react";
import styled from "styled-components";

const Bar = styled.div`
  .ui-progress-bar-bar {
    background-color: #e2e2e2;
    border-radius: 0.2rem;
  }
  .ui-progress-bar-bar > div {
    background-color: #58cc58;
    height: 1rem;
    border-radius: 0.2rem;
    transition: width 0.2s;
  }
`;

const ProgressBar = (props: { loaded: number; total: number }) => {
  let pct = 0;
  if (props.loaded && props.total) {
    pct = (props.loaded / props.total) * 100;
  }

  return (
    <Bar>
      {/* <div className="ui-progress-bar-text">95%</div> */}
      <div className="ui-progress-bar-bar">
        <div
          style={{
            width: `${pct}%`,
          }}
        ></div>
      </div>
    </Bar>
  );
};

export default ProgressBar;
